// extracted by mini-css-extract-plugin
export default {"overlay":"BottomPage_overlay__LkFVT","sheet":"BottomPage_sheet__4aji1","slideUp":"BottomPage_slideUp__PcUSq","handle":"BottomPage_handle__5JVpe"};